export default __webpack_public_path__ + "media/images/manual/joanr/09-6941103aaccd79b48ea40ff96b8e14e9.png";